import { CurrencyConfig } from 'types/api';

/**
 * 동적 화폐 포맷팅 함수
 * @param priceInCents - 서버로부터 받은 가격 값 (USD: 3400 → $34.00, KRW: 14000 → ₩14,000)
 * @param currencyConfig - 화폐 설정 객체
 * @returns 포맷팅된 가격 문자열 (예: "₩44,000", "$440.00")
 */
export const priceFormat = (priceInCents: number, currencyConfig?: CurrencyConfig): string => {
  // currencyConfig가 없으면 기본값으로 USD 사용
  const config = currencyConfig || {
    code: 'USD',
    name: 'US Dollar',
    symbol: '$',
    currencyDecimalPlaces: 2,
  };

  // currencyDecimalPlaces가 0이면 그대로 사용 (원화 등), 아니면 100으로 나누기 (달러 등)
  const priceInMainUnit = config.currencyDecimalPlaces === 0 ? priceInCents : priceInCents / 100;

  // 소수점 자릿수에 따라 포맷팅
  const formatter = new Intl.NumberFormat('en-US', {
    minimumFractionDigits: config.currencyDecimalPlaces,
    maximumFractionDigits: config.currencyDecimalPlaces,
  });

  const formattedNumber = formatter.format(priceInMainUnit);

  // 심볼과 함께 반환
  return `${config.symbol}${formattedNumber}`;
};
